export default {
  GET_LOADING: 'GET_LOADING',
  GET_SIDEBAR_STATE: 'GET_SIDEBAR_STATE',
  GET_PERMISSIONS: 'GET_PERMISSIONS',
  GET_FIELDS_DEFINITIONS: 'GET_FIELDS_DEFINITIONS',
  GET_MOBILE_SIDEBAR_STATE: 'GET_MOBILE_SIDEBAR_STATE',
  GET_ALERT_MESSAGE: 'GET_ALERT_MESSAGE',
  GET_ERROR: 'GET_ERROR',
  GET_ALERT_TYPE: 'GET_ALERT_TYPE',
  GET_API_VERSION: 'GET_API_VERSION'
}
